<template>
  <div class="checkout-step-five" :class="{loading: isLoading}">
    <div class="checkout-step__header">
      <div class="row align-items-end">
        <div class="col-12 col-md-9">
          <!--          <h3 class="checkout-step__headline">{{ $t('pages.checkoutStepFive.title') }}</h3>-->
          <h3 class="checkout-step__headline">{{ getTitle }}</h3>
          <!--          <h4>{{ getPaymentMethodNew }}</h4>-->
          <template v-if="hasNoPaymentProvider">
            <p class="checkout-step__copy"
               v-html="$t('pages.checkoutStepFive.copyTotal', {
                 accommodationType: selectedCampsite.name,
                 campground: campground.name,
                 total: getFormattedValue(price.total),
               })"></p>
            <h4 v-if="getPaymentMethodNew.system === 'ONLINE'"><br>{{ getOnlinePaymentInfo }}</h4>
          </template>
          <template v-else>
            <p class="checkout-step__copy"
               v-if="depositIsPercent"
               v-html="$t('pages.checkoutStepFive.copyPercent', {total: getFormattedValue(price.total), deposit_value: getFormattedValue(price.deposit_value), deposit_percent: price.deposit_percent })"></p>
            <p class="checkout-step__copy"
               v-if="depositIsTotal"
               v-html="$t('pages.checkoutStepFive.copyTotal', {total: getFormattedValue(price.total) })"></p>
            <p class="checkout-step__copy"
               v-if="!depositIsPercent && !depositIsTotal"
               v-html="$t('pages.checkoutStepFive.copy', {total: getFormattedValue(price.total), deposit_value: getFormattedValue(price.deposit_value) })"></p>
          </template>
        </div>
      </div>
      <section class="checkout-step__copy"
               v-if="price.cancellation_terms && price.cancellation_terms.length > 0">
        <br>
        <h3>{{ $t('progress.step2-ct') }}</h3>
        <div v-for="(term, index) in price.cancellation_terms" :key="index">
          {{ term }}
        </div>
      </section>

    </div>

    <!-- currency disclaimer -->
    <div class="checkout__currency-warning"
         :class="{ 'checkout__currency-warning--highlight': selectedCurrencyIsNotDefault }"
         v-if="!hasNoPaymentProvider">
      <div class="warning-title" v-if="selectedCurrencyIsNotDefault">
        <iconWarning class="icon"></iconWarning>
        <span v-html="$t('pages.checkoutStepFive.currencyDisclaimer.title')"></span>
      </div>
      <div class="warning-content"
           v-html="$t('pages.checkoutStepFive.currencyDisclaimer.copy', { currencyName: getCurrency.name, targetUrl: faqUrl('11').href })"></div>
    </div>

    <!-- checkboxes -->
    <form class="checkout--form" v-if="!checkout.status.error" novalidate>
      <div class="form-check" :class="{error: errors.has('toc')}">
        <input type="checkbox" class="form-check-input" id="toc" name="toc"
               v-model="toc" v-validate="{ required: true }">
        <label class="form-check-label" for="toc" v-if="!isBVCD">
          <span v-if="!!urls.toc"
                v-html="$t('pages.checkoutStepFive.toc.hasCampgroundTerms', { terms_url_campground: urls.toc, terms_url_ci: $t('meta.terms_url.ci'), privacy_url_ci: $t('meta.privacy.url') })"></span>
          <span v-else
                v-html="$t('pages.checkoutStepFive.toc.hasNoCampgroundTerms', { terms_url_ci: $t('meta.terms_url.bvcd'), privacy_url_ci: $t('meta.privacy.url') })"></span>
        </label>
        <label class="form-check-label" for="toc" v-else>
          <span v-if="!!urls.toc"
                v-html="$t('pages.checkoutStepFive.tocBvcd.hasCampgroundTerms', { terms_url_campground: urls.toc, terms_url_bvcd: $t('meta.terms_url.bvcd'), privacy_url_bvcd: $t('meta.privacy.url') })"></span>
          <span v-else
                v-html="$t('pages.checkoutStepFive.tocBvcd.hasNoCampgroundTerms', { terms_url_bvcd: $t('meta.terms_url.bvcd'), privacy_url_bvcd: $t('meta.privacy.url') })"></span>
        </label>
      </div>
      <div class="form-check" :class="{error: errors.has('privacy')}" v-if="urls.privacy_policy">
        <input type="checkbox" class="form-check-input" id="privacy" name="privacy"
               v-model="privacy" v-validate="{ required: true }">
        <label class="form-check-label" for="privacy">
          <span
            v-html="$t('pages.checkoutStepFive.privacy', { privacy_url: urls.privacy_policy })"></span>
        </label>
      </div>
      {{ getOnlinePaymentInfo }}
    </form>
    <div class="payment--buttons">
      <CiButton
        v-if="hasNoPaymentProvider && getPaymentMethodNew.system != 'ONLINE'"
        class="checkout__pay-now button--primary"
        :disabled="isSubmitDisabled"
        @click="initPayment"
      >
        {{ $t('pages.checkoutStepFive.payButtonNoPaymentProvider') }}
      </CiButton>
      <CiButton
        v-if="getPaymentMethodNew.system == 'ONLINE'"
        class="checkout__pay-now button--primary"
        :disabled="isSubmitDisabled || this.loading"
        @click="initCardPayment"
      >
        <template v-if="!this.loading">
          <span> {{ $t('pages.checkoutStepFive.payButtonCardPayment') }}</span>
        </template>
        <template v-if="this.loading">
          <span>{{ $t('generic.buttons.loading') }}</span>
          <span class="spinner"></span>
        </template>
      </CiButton>
    </div>
    <!-- adyen payment -->
    <div id="payment-div" v-show="!checkout.status.error"></div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {CiGenericNavigation, CiInfoBox, CiButton, CiProgressNavigation} from '@/components/index'

import iconArrowBlack from '@/assets/icons/arrow-black.svg'
import iconArrowWhite from '@/assets/icons/arrow-white.svg'
import iconWarning from '@/assets/icons/warning-orange.svg'
import {Api} from "@/api/api";
import * as types from "@/store/mutation-types";

const styleObject = {
  base: {
    color: '#000',
    fontSize: '14px',
    lineHeight: '14px',
    fontSmoothing: 'antialiased',
  },
  error: {
    color: 'red',
  },
  placeholder: {
    color: '#d8d8d8',
  },
  validated: {
    color: 'green',
  },
}

let sdkConfigObj = {
  context:
    !process.env.VUE_APP_ADYEN_IS_LIVE || process.env.VUE_APP_ADYEN_IS_LIVE === 'false'
      ? 'test'
      : 'live',
  paymentMethods: {
    card: {
      sfStyles: styleObject,
    },
  },
  translations: {
    payButton: {},
  },
  allowAddedLocales: true,
}

export default {
  name: 'CheckoutStepFive',
  components: {
    CiProgressNavigation,
    CiGenericNavigation,
    CiInfoBox,
    CiButton,
    iconArrowBlack,
    iconArrowWhite,
    iconWarning,
  },
  data() {
    return {
      hasNoPaymentProvider: !!process.env.VUE_APP_NO_PAYMENT_PROVIDER,
      adyenCheckoutObject: null,
      adyenCheckoutObjectTimer: null,
      privacy: false,
      toc: false,
      loading: false,
      isBVCD:
        process.env.VUE_APP_BVCD !== '' &&
        process.env.VUE_APP_BVCD !== null &&
        process.env.VUE_APP_BVCD !== undefined,
    }
  },
  created() {
    if (!this.hasNoPaymentProvider) {
      this.initPayment()
      if (this.bookingConfirmation && this.bookingConfirmation.payment) {
        if (this.bookingConfirmation.payment.success === false) {
          this.$nextTick(() => {
            this.showErrorDialog(
              this.$t('modals.CiPaymentError.title'),
              `${this.$t('modals.CiPaymentError.content')}
            ${this.$t('modals.CiPaymentError.errorGeneric')}`
            )
          })
        }
      }
    }
  },
  mounted() {
    if (!this.hasNoPaymentProvider) {
      this.startAdyenCheckoutObjectTimer()
    }
  },
  computed: {
    ...mapGetters('application', {
      activeStep: 'activeStep',
      currency: 'currency',
      language: 'language',
      steps: 'steps',
    }),

    ...mapGetters('booking', {
      billing: 'billing',
      checkout: 'checkout',
      price: 'price',
      status: 'status',
      bookingConfirmation: 'confirmation',
      selectedCampsite: 'selectedCampsite',
    }),

    ...mapGetters('campground', {
      campground: 'campground',
      currencies: 'currencies',
      sessionTimeout: 'sessionTimeout',
      urls: 'urls',
      paymentInfos: 'paymentInfos',
    }),

    isSubmitDisabled() {
      return this.urls.privacy_policy ? !(this.privacy && this.toc) : !this.toc
    },

    getPaymentMethodNew() {
      if (this.selectedCampsite.campsite_type === 'accommodation') {
        return this.paymentInfos.rentals
      }
      return this.paymentInfos.pitches
    },

    getTitle() {
      if (this.getPaymentMethodNew.system === 'ON_SITE') {
        return this.$t('pages.checkoutStepFive.onSitePayment')
      }
      if (this.getPaymentMethodNew.system === 'INVOICE') {
        return this.$t('pages.checkoutStepFive.invoicePayment')
      }
      return this.$t('pages.checkoutStepFive.payNow')
    },

    getOnlinePaymentInfo() {
      if (this.getPaymentMethodNew.system === 'ONLINE') {
        if (this.depositIsTotal) {
          return this.$t('pages.checkoutStepFive.fullPaymentInfo', {
            deposit: this.getFormattedValue(this.depositAmountToPay)
          })
        }
        else {
          return this.$t('pages.checkoutStepFive.depositPaymentInfo', {
            deposit: this.getFormattedValue(this.depositAmountToPay),
            percent: this.price.deposit_percent
          })
        }
      }
      return ''
    },

    getCurrency() {
      return this.currencies.find(currency => currency.code === this.campground.currency)
    },

    selectedCurrencyIsNotDefault() {
      return this.campground.currency !== this.currency.code
    },

    depositAmountToPay() {
      return this.price.deposit_value
    },

    depositIsTotal() {
      return this.price.deposit_value === this.price.total
    },

    depositIsPercent() {
      return !this.depositIsTotal && this.price.deposit_value !== this.price.minimum_fixed_deposit
    },

    isLoading() {
      if (this.hasNoPaymentProvider) {
        return false
      }

      return !this.adyenCheckoutObject
    },
  },
  methods: {
    ...mapActions('application', {
      resetStepStatus: 'resetStepStatus',
      setLoader: 'setLoader',
      setStepStatus: 'setStepStatus',
    }),

    ...mapActions('booking', {
      performCheckout: 'performCheckout',
      prepareBookingForPayment: 'prepareBookingForPayment',
      processPayload: 'processPayload',
      resetAdyen: 'resetAdyen',
      resetState: 'resetState',
      resetCheckout: 'resetCheckout',
      resetStatus: 'resetStatus',
      setBilling: 'setBilling',
      setCheckout: 'setCheckout',
      resetTimer: 'resetTimer',
    }),

    back() {
      /* reset adyen & status - keep checkout in case no data changes */
      this.resetAdyen()
      this.resetStatus()

      this.$router.push({
        name: 'Step',
        params: {...this.$route.params, step: this.activeStep - 1},
      })
    },

    stopAdyenCheckoutObjectTimer() {
      clearInterval(this.adyenCheckoutObjectTimer)
      this.adyenCheckoutObjectTimer = null
    },

    startAdyenCheckoutObjectTimer() {
      this.stopAdyenCheckoutObjectTimer()
      this.setLoader(true)
      this.adyenCheckoutObjectTimer = setInterval(this.intervalCallback, 50)
    },

    getFormattedValue(value) {
      return this.$options.filters.currency(value, this.campground.currency, this.language.code)
    },

    intervalCallback() {
      if (window['chckt']) {
        this.stopAdyenCheckoutObjectTimer()
        this.adyenCheckoutObject = window['chckt']
        setTimeout(() => {
          this.setLoader(false)
        }, 2500)
        if (this.checkout.responseCheckout.success) {
          const session = this.checkout.responseCheckout.payment.session
          const id = this.checkout.responseCheckout.payment.id
          this.initPaymentDialog(session, id)
        }
      }
    },

    initPayment() {
      this.setLoader(true)
      /* istanbul ignore else */
      return this.performCheckout()
        .then(result => {
          if (this.hasNoPaymentProvider) {
            console.log("RESULT:", result)
            if (result.success) {
              this.setStepStatus({number: 6, key: 'fulfilled', value: false})
              this.setLoader(true)
              this.$router.push({
                name: 'Confirmation',
                params: {
                  ...this.$route.params,
                  bookingId: this.checkout.responseCheckout.booking_id,
                },
              })
            } else {
              this.showStartOverDialog()
            }
          } else {
            if (this.adyenCheckoutObject === null) {
              this.startAdyenCheckoutObjectTimer()
            } else {
              this.initPaymentDialog(result.payment.session, result.payment.id)
            }
          }
        })
        .catch(() => {
          // TODO: ADD SENTRY LOGGING
          this.showStartOverDialog()
        })
    },

    initCardPayment() {
      /* istanbul ignore else */
      this.loading = true;
      return this.performCheckout()
        .then(result => {
          if (this.hasNoPaymentProvider) {
            if (result.success) {
              this.$router.push({
                name: 'StripePayment',
                params: {
                  ...this.$route.params,
                  bookingId: this.checkout.responseCheckout.booking_id,
                },
              })
            } else {
              this.showStartOverDialog()
            }
          } else {
            if (this.adyenCheckoutObject === null) {
              this.startAdyenCheckoutObjectTimer()
            } else {
              this.initPaymentDialog(result.payment.session, result.payment.id)
            }
          }
        })
        .catch(() => {
          // TODO: ADD SENTRY LOGGING
          this.showStartOverDialog()
        })
    },

    initPaymentDialog(session, id) {
      if (this.adyenCheckoutObject === null) {
        setTimeout(() => {
          this.initPaymentDialog()
        }, 100)
        return
      }

      this.setLoader(false)

      sdkConfigObj.translations.payButton[
        this.checkout.responseCheckout.payment.shopperLocale
        ] = this.$t('pages.checkoutStepFive.payButton')
      if (this.campground.testmode) {
        sdkConfigObj.context = 'test'
      }

      /* istanbul ignore next */
      this.adyenCheckoutObject.checkout(session, '#payment-div', sdkConfigObj)

      /* istanbul ignore next */
      this.adyenCheckoutObject.hooks.onSubmitAction = () => {
        /* reset status  */
        this.resetStatus()

        /* validate checkboxes */
        this.$validator.validateAll().then(result => {
          if (result) {
            this.setLoader(true)
            this.prepareBookingForPayment({bookingId: this.checkout.responseCheckout.booking_id})
              .then(() => {
                this.resetTimer()
                this.adyenCheckoutObject.submitPaymentForm()
              })
              .catch(() => {
                this.onSessionExpired()
              })

            // Give all paymentMethod divs a disabled state
            this.adyenCheckoutObject.toggleEnableAllPaymentMethods(false)

            // Hide the 'pay' & 'show more payment methods' buttons
            this.adyenCheckoutObject.toggleActionButton(false)
            this.adyenCheckoutObject.toggleShowMorePMsButton(false)
          } else {
            let errors = []
            Object.values(this.$validator.errors.items).forEach(item => {
              if (item.field === 'toc') {
                errors.push('terms_checkbox')
              } else {
                errors.push(`${item.field}_checkbox`)
              }
            })
            this.$el.querySelector('.checkout--form').scrollIntoView({behavior: 'smooth'})
          }
        })

        /* block default functionality */
        return false
      }

      /* istanbul ignore next */
      this.adyenCheckoutObject.hooks.beforeComplete = (node, paymentData) => {
        this.setLoader(true)
        this.onProcessPayload(id, paymentData)
      }

      this.adyenCheckoutObject.hooks.handleError = () => {
        this.onAdyenError({})
        return false
      }
    },

    onProcessPayload(id, paymentData) {
      return this.processPayload({id, payload: paymentData.payload})
        .then(result => {
          this.setCheckout({key: 'responseAdyen', value: result})

          /* if case of success result.success === true */
          if (result.success) {
            this.$router.push({
              name: 'Confirmation',
              params: {
                ...this.$route.params,
                bookingId: this.checkout.responseCheckout.booking_id,
              },
            })
          } else {
            this.onAdyenError(result)
          }
        })
        .catch(() => {
          this.showStartOverDialog()
        })
    },

    onAdyenError(result) {
      this.showErrorDialog(
        this.$t('modals.CiPaymentError.title'),
        `${this.$t('modals.CiPaymentError.content')} ${
          result.refusalReason === 'CVC Declined'
            ? this.$t('modals.CiPaymentError.errorCVC')
            : this.$t('modals.CiPaymentError.errorGeneric')
        }`,
        this.reInitPaymentWithCheckoutResponse
      )
      this.setLoader(false)
    },

    reInitPaymentWithCheckoutResponse() {
      this.resetCheckout()
      this.initPayment()
    },

    reInitPayment() {
      this.setLoader(true)
      this.resetAdyen()
      this.resetStatus()
      this.resetCheckout()

      this.initPayment()
    },

    onSessionExpired() {
      this.setCheckout({key: 'responseAdyen', value: {}})
      this.showErrorDialog(
        this.$t('modals.CiSessionExpired.title'),
        this.$t('modals.CiSessionExpired.contentPaymentRestart'),
        this.reInitPayment
      )
      this.setLoader(false)
    },

    showStartOverDialog() {
      let errorContent = this.$t('modals.CiCheckoutGenericError.content')
      if (
        this.checkout.responseCheckout.data &&
        this.checkout.responseCheckout.data.non_field_errors &&
        this.checkout.responseCheckout.data.non_field_errors.length
      ) {
        errorContent = this.checkout.responseCheckout.data.non_field_errors[0]
      }
      this.showErrorDialog(
        this.$t('modals.CiCheckoutGenericError.title'),
        errorContent,
        this.startOver
      )
      this.setLoader(false)
    },

    startOver() {
      /* go back to step 1 */
      this.$router.push({
        name: 'Step',
        params: {...this.$route.params, step: 1},
      })

      /* reset booking state */
      this.resetState()

      /* reset step status */
      this.resetStepStatus()
    },

    showErrorDialog(title, content, proceedAction = () => {
    }, proceedButtonText = null) {
      this.$modal.show('dialog', {
        buttons: {
          primary: {
            active: true,
            classes: 'button--primary button--center',
            text: proceedButtonText,
          },
          secondary: {active: false},
        },
        content: content,
        proceedEvent: proceedAction, //this.reInitPayment,
        title: title,
      })
    },

    faqUrl(id) {
      return this.$router.resolve({name: 'FAQ', params: this.$route.params, query: {q: id}})
    },
  },
  destroyed() {
    this.stopAdyenCheckoutObjectTimer()
  },
}
</script>

<style lang="scss">
.chckt-sdk {
  float: none;
}

.chckt-pm__header {
  padding: 20px 23px;

  .chckt-pm__image {
    margin-left: 13px;
  }
}

.chckt-form-label__text {
  color: black;
  display: inline-block;
  font-family: gotham_mediumregular, Avenir, Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  margin-bottom: 0.5rem;
  position: relative;
}

.chckt-input-field--focus {
  border-color: var(--primary-color);
}

.chckt-input-field {
  background-color: #fff;
  border-radius: 4px;
  color: #495057;
  display: block;
  font-size: 1rem;
  line-height: 1rem;
  padding: 20px 15px;
  width: 100%;
  height: 60px;
}

.chckt-input-field--error {
  border: 1px solid $primary-red;
  color: $primary-red;
}

.chckt-form-label__error-text {
  color: $primary-red;
}

.chckt-button {
  background-color: var(--primary-color);
  border-radius: 37.5px;

  .no-touch &:hover {
    background-color: var(--primary-color);
  }

  &.chckt-button--disabled {
    background-color: #9b9b9b;

    .no-touch &:hover {
      background-color: #9b9b9b;
    }
  }
}

.warning-content a,
.form-check-label a {
  color: black;
  text-decoration: underline;
}

.form-check.error .form-check-label a {
  color: $primary-red;
  text-decoration: underline;
}
</style>

<style lang="scss" scoped>
.checkout-step-five.loading {
  opacity: 0.5;
}

.checkout-step-five__header {
  margin: 0 0 30px;
}

.checkout-step-five__headline {
  @include font-format(1.375rem, 1.625em);
}

.checkout-step-five__copy {
  margin: 0;

  &.checkout-step-five__copy--small {
    @include font-format(0.625em, 0.875em);
  }
}

.checkout--form {
  margin: 30px 0;
}

.payment--buttons {
  display: flex;
  justify-content: space-evenly;
}

.checkout__currency-warning {
  @include font('gotham_bookregular');
  @include font-format(0.75rem, 1.25rem);

  font-style: italic;
  background-color: transparent;
  border: 0 solid #d6d6d6;
  margin: 15px 0 0 0;

  .warning-title {
    position: relative;
    background-color: #f8e71c66;
    padding: 10px 25px 10px 60px;

    .icon {
      position: absolute;
      left: 20px;
      top: 10px;
      width: 20px;
      height: auto;
    }
  }

  .warning-content {
    padding: 0;
  }

  .warning-title + .warning-content {
    padding: 10px 25px 10px 60px;
  }

  &.checkout__currency-warning--highlight {
    border: 1px solid #f8e71c;
    background-color: #fefcdd;

    .warning-content {
      padding: 10px 25px 10px 25px;
    }
  }
}

.checkout__pay-now {
}
</style>
